import { Injectable } from '@angular/core';
import { ConfigurationService } from '@sc/data-access-configuration';
import { FeatureFlippingManagerBaseService } from '@sc/data-access-models';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlippingManagerService extends FeatureFlippingManagerBaseService {
  constructor(private readonly configService: ConfigurationService) {
    super(configService.getConfig());
  }
}
